import styled from 'styled-components';

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr repeat(12, minmax(auto, 4.78rem)) 1fr;
  grid-column-gap: 16px;
  background-color: ${({ theme }) => theme.colors.gray950};
`;
